import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import Swiper from 'react-id-swiper';
import { connect } from 'react-redux';
import { Link } from '../../routes';
import { HotelCard, Skeleton } from '../index';
import { ArrowRight, slugify, axiosInstance } from '../../utils';

import {
  AlsoBoughtSection,
  AlsoBoughtContainer,
  AlsoBoughtHeader,
  AlsoBoughtHeading,
  AlsoBoughtButton,
  AlsoBoughtSlider,
  AlsoBoughtSlide,
} from './styles';

const renderButton = referer => (
  <Link href={referer}>
    <a target="_blank">
      <AlsoBoughtButton btnType="secondary">
        Show Me More
        <ArrowRight width={16} height={12} />
      </AlsoBoughtButton>
    </a>
  </Link>
);

const params = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  freeMode: true,
};

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
  isMobile: width < 768,
});

const mapStateToProps = state => ({
  currentHotelName: state.userProduct.hotel.name,
  userPreferences: state.userPreferences,
});

@withSizes(mapSizesToProps)
@connect(mapStateToProps)
class HotelAlsoBought extends Component {
  static propTypes = {
    userPreferences: PropTypes.instanceOf(Object),
    isTablet: PropTypes.bool,
    isMobile: PropTypes.bool,
    referer: PropTypes.string,
    currentHotelName: PropTypes.string,
  };

  state = {
    featured: ['temp'],
  };

  swiper = null;

  async componentDidMount() {
    const { currentHotelName, userPreferences: { date, guests, city, product, experience } } = this.props;

    const { data: searchData } = await axiosInstance
      .get(`products/search?product=${product}&market=${`${city.market},${city.adminCode}`}&date=${date}&guests=${guests}&priceHi=100&priceLo=0&distanceHi=0&distanceLo=0&sortType=2&experience=${experience}&limit=6&offset=0`);
    const filteredSearchData = searchData.data
      .filter(hotel => hotel.hotelName !== currentHotelName)
      .sort(
        (a, b) => a.distance.toFixed(0) - b.distance.toFixed(0) || a.reviewsTotal - b.reviewsTotal,
      );

    this.setState({
      featured: filteredSearchData,
    });
  }

  render() {
    const { featured } = this.state;
    const { referer, isMobile, isTablet } = this.props;

    return (
      featured.length !== 0 && (
        <AlsoBoughtSection>
          <AlsoBoughtContainer>
            <AlsoBoughtHeader>
              <AlsoBoughtHeading>Customers Also Bought</AlsoBoughtHeading>
              {isTablet && renderButton(referer)}
            </AlsoBoughtHeader>
            <AlsoBoughtSlider>
              <Swiper
                {...params}
                ref={node => {
                  if (node) this.swiper = node.swiper;
                }}
              >
                {featured[0] === 'temp'
                  ? Array(6)
                      .fill(0)
                      .map((hotel, index) => (
                        <AlsoBoughtSlide key={index}>
                          <Skeleton height={230} marginBottom={15} />
                          <Skeleton height={20} marginBottom={5} />
                          <Skeleton height={20} marginBottom={10} />
                          <Skeleton height={20} />
                        </AlsoBoughtSlide>
                      ))
                  : featured.map((hotel, index) => (
                    <AlsoBoughtSlide key={index}>
                      <Link
                        route="product"
                        params={{
                            marketName: slugify(hotel.hotelCity),
                            hotelName: slugify(hotel.hotelName),
                            hid: hotel.hotelId,
                            pid: hotel.id,
                          }}
                      >
                        <a>
                          <HotelCard image={hotel.image} {...hotel} />
                        </a>
                      </Link>
                    </AlsoBoughtSlide>
                ))}
              </Swiper>
            </AlsoBoughtSlider>
            {isMobile && renderButton(referer)}
          </AlsoBoughtContainer>
        </AlsoBoughtSection>
      )
    );
  }
}

export default HotelAlsoBought;
